const facets = {
  es: {
    blender: "ESPONJA",
    blush: "BLUSH",
    bodyjewel: "BRILLOS CORPORALES",
    bodym: "BODY SPLASH MAN",
    bodymist: "BODY MIST",
    cleansing: "LIMPIEZA FACIAL",
    eyebrow: "CEJAS",
    eyelash: "PESTAÑAS",
    eyeliner: "DELINEADOR",
    eyeshadows: "SOMBRAS",
    foundation: "BASES MAQUILLAJE",
    hairbru: "CEPILLOS",
    handsan: "DESINFECTANTES",
    iron: "PLANCHAS CABELLO",
    lipbalm: "BALSAMOS LABIAL",
    lipgloss: "BRILLOS LABIALES",
    lipstick: "LABIALES",
    makeupbr: "BROCHAS",
    makeupca: "COSMETIQUERAS, ESTUCHES, NECESERES",
    makeuphb: "VALERINAS",
    mascara: "MASCARA DE PESTAÑAS",
    mask: "MASCARILLAS FACIALES",
    mirror: "ESPEJOS",
    moisturiz: "HIDRATANTES DE PIEL",
    nailpol: "ESMALTES",
    nails: "UÑAS",
    perfume: "PERFUMES",
    sanitizer: "SANITIZANTES",
    tattoos: "TATUAJES TEMPORALES",
    tweezers: "PINZAS",
    backpackm: "MOCHILAS MAN",
    beaniem: "GORROS/ BEANIES MAN",
    beltsm: "CINTURONES MAN",
    bottlem: "BOTELLAS MAN",
    celaccem: "ACCESORIOS PARA CELULAR MAN",
    celcasem: "FUNDAS MAN",
    glovesm: "GUANTES MAN",
    hatm: "SOMBREROS MAN",
    hipflaskm: "LICORERAS DE BOLSILLO MAN",
    keychainm: "LLAVEROS MAN",
    mugm: "TAZAS MAN",
    scarfm: "BUFANDAS MAN",
    sunglassm: "LENTES DE SOL MAN",
    thermom: "TERMOS MAN",
    tumblerm: "VASOS MAN",
    walletm: "CARTERAS MAN",
    blazerm: "SACOS",
    boxerm: "ROPA INTERIOR",
    denjacm: "CHAMARRAS DENIM",
    denshtm: "SHORTS DENIM",
    hoodiesm: "SUDADERAS",
    jeansm: "JEANS",
    joggersm: "JOGGERS",
    lightjm: "CHAMARRAS LIGERAS",
    noshowsm: "ROPA INTERIOR",
    pantsm: "PANTALONES",
    pijamasm: "PIJAMAS",
    polom: "POLOS",
    pufferjm: "CHAMARRAS ACOLCHADAS",
    shirtm: "CAMISAS",
    shortsm: "SHORTS",
    socksm: "CALCETINES",
    sweaterm: "SUÉTERES",
    swimsuitm: "TRAJES DE BAÑO",
    tankm: "TANK TOPS",
    tshirtm: "PLAYERAS",
    vestm: "CHALECOS",
    braceletm: "BARZALETES MAN",
    basicsnm: "TENIS BASICOS MAN",
    chelseabm: "BOTAS CHELSEA MAN",
    combatbm: "BOTAS COMBAT MAN",
    flipfm: "FLIP FLOPS MAN",
    runnerm: "TENNIS RUNNER MAN",
    sandalsm: "SANDALIAS MAN",
    anklets: "TINES",
    aviator: "AVIADOR",
    backpacks: "MOCHILAS",
    beacht: "TOALLA DE PLAYA",
    beanie: "GORROS/ BEANIES",
    belts: "CINTURONES",
    bottle: "BOTELLAS",
    bowling: "BOLSA AL HOMBRO",
    careh: "HOGAR | CUIDADO",
    cases: "FUNDAS",
    cateye: "CAT EYE",
    celacces: "ACCESORIOS PARA CELULAR",
    chargers: "CARGADORES",
    chocolates: "CHOCOLATES",
    clubma: "CLUB MASTER",
    clutches: "CLUTCHES",
    collars: "COLLARES",
    computer: "COMPUTADORA",
    crossbody: "CROSSBODY",
    decoration: "DECORACIÓN",
    deskacces: "ACCESORIOS DE ESCRITORIO",
    earmuffs: "OREJERAS",
    eyemask: "ANTIFACES",
    fannypack: "CANGURERAS",
    fashcaps: "GORRAS",
    fedora: "FEDORAS",
    float: "INFLABLES",
    floppy: "SOMBREROS",
    gloves: "GUANTES",
    gymbag: "GYM BAGS",
    headphones: "AUDÍFONOS",
    keychain: "LLAVEROS",
    kitchen: "COCINA",
    legwarmer: "CALENTADORES",
    lights: "LUCES",
    lightways: "PASHMINAS LIGERAS",
    longsocks: "CALCETAS LARGAS",
    marker: "MARCADORES",
    mug: "TAZAS",
    neckerchie: "PAÑUELOS",
    notebooks: "LIBRETAS",
    nshows: "CUBREPIES",
    nslips: "PANTUCALCETAS",
    oversized: "OVERSIZED",
    panama: "PANAMA",
    party: "ENTRETENIMIENTO",
    pens: "PLUMAS",
    pettoys: "JUGUETES",
    petwear: "MODA PARA MASCOTA",
    pinpa: "PINES | PARCHES",
    plush: "PELUCHES",
    round: "REDONDOS",
    scarves: "BUFANDAS",
    slime: "SLIME",
    snacks: "SNACKS",
    socks: "CALCETINES",
    spicy: "DULCES PICANTES",
    squish: "SQUISHIES",
    stocking: "MEDIAS",
    suitcase: "MALETAS",
    sunglassc: "FUNDAS PARA LENTES",
    sweet: "DULCES",
    thermo: "TERMOS",
    tights: "MALLAS",
    totes: "TOTES",
    travelacc: "ACCESORIOS DE VIAJE",
    travelp: "COJINES DE VIAJE",
    tumbler: "VASOS",
    umbrella: "SOMBRILLAS",
    wallets: "CARTERAS",
    wayfarer: "WAFARER",
    winterhat: "SOMBREROS DE INVIERNO",
    winterhb: "VALERINAS",
    bermuda: "BERMUDAS",
    bikini: "BIKINI",
    blazer: "SACOS",
    blouses: "BLUSAS",
    bodysuit: "BODYSUITS",
    boxer: "BOXER",
    bra: "BRAS",
    braacces: "BRA ACCES",
    bralette: "BRALETTES",
    camise: "CAMISAS",
    cardigan: "CARDIGANS",
    coat: "ABRIGOS",
    daydress: "VESTIDOS DE DÍA",
    dendress: "VESTIDOS DENIM",
    denjacket: "CHAMARRAS DENIM",
    denshorts: "SHORTS DENIM",
    denskirt: "FALDAS DENIM",
    dentops: "TOPS DENIM",
    denvest: "CHALECOS DENIM",
    jeans: "JEANS",
    jogger: "JOGGERS",
    jumpsuit: "JUMPSUIT",
    kimono: "KIMONO",
    leggings: "LEGGINGS",
    lightjac: "CHAMARRAS LIGERAS",
    lightvest: "CHALECOS LIGEROS",
    maxidress: "MAXI VESTIDOS",
    maxiskirt: "MAXI FALDAS",
    midiskirt: "MIDI FALDAS",
    miniskirt: "MINI FALDAS",
    nightdres: "VESTIDOS DE NOCHE",
    overalls: "OVEROLES",
    pants: "PANTALONES",
    pijama: "PIJAMA",
    ponchos: "PONCHOS",
    pufferjac: "CHAMARRAS ACOLCHADAS",
    romper: "ROMPERS",
    shorts: "SHORTS",
    sweater: "SUÉTERES",
    sweatshirt: "SUDADERAS",
    swimsuit: "TRAJES DE BAÑO",
    thong: "PANTIES",
    tops: "TOPS",
    trenchcoa: "GABARDINAS",
    tshirts: "PLAYERAS",
    vest: "CHALECOS",
    anklet: "BRAZALETES DE TOBILLO",
    bangles: "SETS DE BRAZALETES",
    blister: "SETS DE ARETES",
    bracelet: "BRAZALETES",
    choker: "CHOKERS",
    cuffs: "CUFFS",
    drops: "COLGANTES",
    earcuffs: "EAR CUFFS",
    hairband: "DIADEMAS",
    hairbow: "MOÑOS",
    hairclip: "PINZAS",
    hairties: "LIGAS",
    headband: "HEAD BANDS",
    hoops: "ARRACADAS",
    longneckl: "COLLARES LARGOS",
    pendant: "COLLARES CON DIJE",
    ring: "ANILLOS",
    ringwatch: "ANILLOS RELOJ",
    stateneck: "COLLARES CHUNKY | BODY CHAINS",
    studs: "ARETES DE PIN",
    watch: "RELOJES",
    ballerina: "BALERINAS",
    bambasn: "TENIS CASUALES",
    bootiessl: "PANTUFLAS DE BOTA",
    casualbt: "BOTINES CASUALES",
    casuals: "SANDALIAS CASUALES",
    casualsn: "TENIS CASUALES RETRO",
    chelseabt: "BOTINES CHELSEA",
    combatbo: "BOTAS COMBAT",
    combatbt: "BOTINES COMBAT",
    cowboybt: "BOTINES VAQUEROS",
    gladiator: "SANDALIAS GLADIADOR",
    highh: "TACONES ALTOS",
    hikingbt: "BOTAS HIKING",
    loafer: "LOAFERS",
    lowh: "TACONES BAJOS",
    mules: "SANDALIAS MULAS",
    mulesl: "PANTUFLAS MULAS",
    overknbt: "BOTAS OVERKNEE",
    oxford: "ZUECOS",
    plattfosn: "TENIS CANVAS",
    pumph: "TACONES PUNTALES",
    runnersn: "TENIS RUNNER",
    slideonf: "FLIP FLOPS",
    underkbt: "BOTAS UNDERKNEE",
    wedges: "CUÑAS"
  }
}